import React from 'react';
import styles from './UserInfo.module.scss';
import Avatar from '@mui/material/Avatar';

export const UserInfo = ({ avatarUrl, fullName, additionalText }) => {
  return (
    <div className={styles.root}>
      <Avatar
        className={styles.avatar}
        src={avatarUrl}
        alt={fullName}
        sx={{ width: 60, height: 70 }}
      >
        {!avatarUrl && fullName?.[0]?.toUpperCase()}
      </Avatar>
      <div className={styles.userDetails}>
        <span className={styles.userName}>{fullName}</span>
        <span className={styles.additional}>{additionalText}</span>
      </div>
    </div>
  );
};

